import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  firstSlideHeading: {
    id: 'app.signup.carousel.first_slide_heading',
    description: 'Instruction to put time clock on wall',
    defaultMessage: 'Place your time clock on the wall',
  },
  firstSlideBody: {
    id: 'app.signup.carousel.first_slide_body',
    description: 'Further details on putting time clock on wall',
    defaultMessage: 'Start by putting your time clock on the wall. We recommend' +
    ' putting it somewhere that is easily visible to staff.',
  },
  secondSlideHeading: {
    id: 'app.signup.carousel.second_slide_heading',
    description: 'Instructing to staff to clock in',
    defaultMessage: 'Staff clock in',
  },
  secondSlideBody: {
    id: 'app.signup.carousel.second_slide_body',
    description: 'Further details on clocking in',
    defaultMessage: 'As staff arrive and leave work, they will clock in and out' +
    ' using a 4 digit passcode. A photo will be taken when they do!',
  },
  thirdSlideHeading: {
    id: 'app.signup.carousel.third_slide_heading',
    description: 'Describing automated timesheets',
    defaultMessage: 'Automate timesheets',
  },
  thirdSlideBody: {
    id: 'app.signup.carousel.third_slide_body',
    description: 'Further describing automated timesheets',
    defaultMessage: 'Staff clock ins and clock outs will appear in your My Tanda' +
    ' account, which you can see on your computer.',
  },
  fourthSlideHeading: {
    id: 'app.signup.carousel.fourth_slide_heading',
    description: 'Instructing to clock in with passcode',
    defaultMessage: 'Get started by clocking in with your passcode:',
  },
  getStartedButton: {
    id: 'app.signup.carousel.get_started_button',
    description: 'Calling use to start clocking in',
    defaultMessage: 'Start clocking in',
  },
  fourthSlideBody: {
    id: 'app.signup.carousel.fourth_slide_body',
    description: 'Instructing to visit my.tanda.co',
    defaultMessage: 'After you clock in, visit your My Tanda account to see your photo!',
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_carousel/i18n.js